import React from 'react';
import { Skeleton } from '../../../Skeleton';
const SkeletonLoader = () => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      padding: '1rem',
      display: 'flex',
      flexDirection: 'column',
      rowGap: '0.5rem'
    }
  }, /*#__PURE__*/React.createElement(Skeleton, {
    height: 24,
    width: "80%"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    height: 24,
    width: "50%"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    height: 24,
    width: "90%"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    height: 24,
    width: "70%"
  })));
};
export default SkeletonLoader;